import { makeStyles } from '@material-ui/core/styles';
import { Colors } from '../../shared/constants';

export default makeStyles((theme) => ( {
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: 'block',
    width: 'fit-content',
    height: '100%',
    margin: '6px auto 0',

    '& + p': {
      textAlign: 'center',
    },
  },

  tabHeader: {
    backgroundColor: '#FFFFFF',
    border: `1px solid ${Colors.primaryAction}`,
    borderRadius: '4px',
    '& div': {
      display: 'flex',
      justifyContent: 'center',
    },
    '& .MuiTab-root': {
      color: Colors.primaryAction,
      borderInlineEnd: `1px solid ${Colors.primaryAction}`,
      fontFamily: 'Noto Sans Hebrew, sans-serif',
      fontSize: '16px',
    },
    '& .MuiTab-root:last-child': {
      borderInlineEnd: 'none',
    },
    '& .Mui-selected': {
      fontWeight: 700,
    },
  },

  tabHeaderReverse: {
    backgroundColor: '#FFFFFF',
    border: `1px solid ${Colors.primaryAction}`,
    borderRadius: '4px',
    '& .MuiTab-root': {
      color: Colors.primaryAction,
      borderInlineEnd: `1px solid ${Colors.primaryAction}`,
      fontFamily: 'Noto Sans Hebrew, sans-serif',
      fontSize: '16px',
    },
    '& .MuiTab-root:last-child': {
      borderInlineEnd: 'none',
    },
    '& .Mui-selected': {
      fontWeight: 700,
    },
  },

  indicator: {
    backgroundColor: Colors.primaryAction,
  },

  dropzone: {
    borderRadius: '4px',
    width: '100%',
    minHeight: '150px',
    padding: '20px 0',
    backgroundColor: 'rgba(78, 78, 78, 0.1)',
    border: '2px dashed rgba(78, 78, 78, 0.4)',
    flexShrink: '0',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'all 0.1s linear',
  },

  onDrag: {
    borderRadius: '4px',
    width: '100%',
    minHeight: '150px',
    padding: '20px 0',
    backgroundColor: 'rgba(78, 78, 78, 0.1)',
    flexShrink: '0',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'all 0.1s linear',
    border: `2px dashed ${Colors.primary}`,
    boxShadow: '0px 10px 100px #e7f0f7',
  },
  fileUploadButtonsContainer: {
    display: "flex",
    justifyContent: "space-between",
    padding: "0 24px"
  },

  button: {
    backgroundColor: Colors.primaryAction,
    fontFamily: 'Noto Sans Hebrew, sans-serif',
    fontSize: '16px',

    '&:hover': {
      backgroundColor: Colors.primaryAction,
    },
  },

  removeButton: {
    backgroundColor: 'none',
    color: Colors.primaryAction,
    fontFamily: 'Noto Sans Hebrew, sans-serif',
    fontSize: '16px',
  },

  file: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: "0 24px"
  },

  fileError: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: '1px solid red',
    borderRadius: '4px',
    margin: '5px 0',
  },

  fileName: {
    display: 'flex',
    alignItems: 'center',
  },

  fileNameRevert:{
    display: 'flex',
    alignItems: 'center',
  
},

  report: {
    maxWidth: 'fit-content',
    textAlign: 'left',
  },
} ));
